import React from 'react';
import { HomeIcon, SearchIcon, LibraryIcon, PlusSquareIcon, HeartIcon, FilmIcon } from 'lucide-react';
import { LibraryView } from './LibraryView';
const LIBRARY_ITEMS = [{
  id: '1',
  title: 'Liked Songs',
  subtitle: '274 songs',
  imageUrl: 'https://misc.scdn.co/liked-songs/liked-songs-640.png',
  type: 'playlist',
  pinned: true
}, {
  id: '2',
  title: 'Daily Mix 1',
  subtitle: 'Playlist • Spotify',
  imageUrl: 'https://dailymix-images.scdn.co/v2/img/ab6761610000e5ebcdce7620dc940db079bf4952/1/en/default',
  type: 'playlist'
}, {
  id: '3',
  title: 'Discover Weekly',
  subtitle: 'Playlist • Spotify',
  imageUrl: 'https://newjams-images.scdn.co/image/ab676477000033ad/dt/v3/discover-weekly/aAbca4VNfzWuUCQ_FGiEFA==/bmVuZW5lbmVuZW5lbmVuZQ==',
  type: 'playlist'
}, {
  id: '4',
  title: 'Release Radar',
  subtitle: 'Playlist • Spotify',
  imageUrl: 'https://newjams-images.scdn.co/image/ab67647800003f8a/dt/v3/release-radar/ab6761610000e5eb8ae7f2aaa9817a704a87ea36/en',
  type: 'playlist'
}];
interface SidebarProps {
  onNavigate: (view: string) => void;
  currentView: string;
  onLibraryItemClick: (item: any) => void;
}
export const Sidebar = ({
  onNavigate,
  currentView,
  onLibraryItemClick
}: SidebarProps) => {
  return <div className="bg-black w-[280px] min-w-[280px] flex flex-col h-full" data-id="element-653">
      <div className="p-6" data-id="element-654">
        <img src="https://storage.googleapis.com/pr-newsroom-wp/1/2018/11/Spotify_Logo_RGB_White.png" alt="Spotify" className="h-[40px] mb-6" onClick={() => onNavigate('home')} style={{
        cursor: 'pointer'
      }} data-id="element-655" />
        <nav className="mb-6 space-y-2" data-id="element-656">
          <button onClick={() => onNavigate('home')} className={`flex items-center w-full p-3 text-[16px] font-bold rounded-md transition-colors ${currentView === 'home' ? 'text-white bg-[#282828]' : 'text-[#b3b3b3] hover:text-white'}`} data-id="element-657">
            <HomeIcon className="w-[24px] h-[24px] mr-4" data-id="element-658" />
            <span data-id="element-659">Home</span>
          </button>
          <button onClick={() => onNavigate('search')} className={`flex items-center w-full p-3 text-[16px] font-bold rounded-md transition-colors ${currentView === 'search' ? 'text-white bg-[#282828]' : 'text-[#b3b3b3] hover:text-white'}`} data-id="element-660">
            <SearchIcon className="w-[24px] h-[24px] mr-4" data-id="element-661" />
            <span data-id="element-662">Search</span>
          </button>
          <button onClick={() => onNavigate('movies')} className={`flex items-center w-full p-3 text-[16px] font-bold rounded-md transition-colors ${currentView === 'movies' ? 'text-white bg-[#282828]' : 'text-[#b3b3b3] hover:text-white'}`} data-id="element-663">
            <FilmIcon className="w-[24px] h-[24px] mr-4" data-id="element-664" />
            <span data-id="element-665">Movies</span>
          </button>
        </nav>
        <div className="pt-2 space-y-2" data-id="element-666">
          <button className="flex items-center w-full p-3 text-[16px] font-bold text-[#b3b3b3] hover:text-white rounded-md transition-colors" onClick={() => onNavigate('library')} data-id="element-667">
            <LibraryIcon className="w-[24px] h-[24px] mr-4" data-id="element-668" />
            <span data-id="element-669">Your Library</span>
          </button>
          <button className="flex items-center w-full p-3 text-[16px] font-bold text-[#b3b3b3] hover:text-white rounded-md transition-colors" onClick={() => onNavigate('createPlaylist')} data-id="element-670">
            <PlusSquareIcon className="w-[24px] h-[24px] mr-4" data-id="element-671" />
            <span data-id="element-672">Create Playlist</span>
          </button>
          <button className="flex items-center w-full p-3 text-[16px] font-bold text-[#b3b3b3] hover:text-white rounded-md transition-colors" onClick={() => onLibraryItemClick(LIBRARY_ITEMS[0])} data-id="element-673">
            <HeartIcon className="w-[24px] h-[24px] mr-4" data-id="element-674" />
            <span data-id="element-675">Liked Songs</span>
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto" data-id="element-676">
        <LibraryView items={LIBRARY_ITEMS} onSearch={query => console.log('Search library:', query)} onItemClick={onLibraryItemClick} data-id="element-677" />
      </div>
    </div>;
};